import { InjectionToken } from '@angular/core';

export type CaptureEventAttributes = Readonly<Record<string, string | number | boolean | undefined>>;

export type CaptureEventName =
  | 'capture_started'
  | 'capture_torch_toggled'
  | 'capture_completed'
  | 'capture_fallback'
  | 'capture_rejected';

export interface CaptureTelemetry {
  recordCaptureEvent(name: CaptureEventName, attributes?: CaptureEventAttributes): void;
}

export const NO_OP_CAPTURE_TELEMETRY: CaptureTelemetry = {
  recordCaptureEvent: (): void => undefined
};

export const CAPTURE_TELEMETRY = new InjectionToken<CaptureTelemetry>('CAPTURE_TELEMETRY', {
  providedIn: 'root',
  factory: () => NO_OP_CAPTURE_TELEMETRY
});
